import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { captureException } from '@sentry/angular';
import { ShiftClientCommentWithResolvedClient } from '@wilson/interfaces';
import { ShiftsService } from '@wilson/shifts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ClientCommentComponent } from './client-comment/client-comment.component';

export interface ClientCommentChange {
  id: string;
  comment: string;
}

@Component({
  selector: 'wilson-shift-client-comments-section',
  templateUrl: './client-comments-section.component.html',
  styleUrl: './client-comments-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, ClientCommentComponent],
})
export class ClientCommentsSectionComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly shiftsService = inject(ShiftsService);
  private readonly message = inject(NzMessageService);
  private readonly translate = inject(TranslateService);

  readonly shiftId = input.required<string>();
  readonly comments = input.required<
    ShiftClientCommentWithResolvedClient[] | undefined
  >();
  readonly refresh = output<void>();

  protected updateClientComment(change: ClientCommentChange): void {
    this.shiftsService
      .updateShiftClientComment(this.shiftId(), change.id, change.comment)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.refresh.emit(),
        error: (error) => {
          captureException(error);
          this.message.error(
            this.translate.instant('general.something_went_wrong'),
          );
        },
      });
  }
}
